// src/components/customers/tabs/tabs-IpAddresses.jsx
import React from "react";
export default function IpAddressesTab() {
  return <div className="oc-empty">No IPs</div>;
}

